<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>The Company</legend>

			<div class="form__group">
				<input id="company" name="company name" class="form__control" v-model="formData.companyName"
				       placeholder="Enter company's name here..." v-validate required />
				<label for="company" class="form__label">Client company name</label>
				<div class="form__validation">{{ errors.first('company name') }}</div>
			</div>

			<div class="form__group">
				<input id="location" name="location" class="form__control" v-model="formData.location"
				       placeholder="Enter the location of activities here..." v-validate required />
				<label for="location" class="form__label">Location of Activities</label>
				<div class="form__validation">{{ errors.first('location') }}</div>
			</div>

			<div class="form__group">
				<input id="website" name="website" class="form__control" v-model="formData.website"
				       placeholder="Enter company's website address here..." v-validate required />
				<label for="website" class="form__label">Website</label>
				<div class="form__validation">{{ errors.first('website') }}</div>
			</div>

			<div class="form__group">
				<textarea id="bio" name="company bio" class="form__control" v-model="formData.description"
				          placeholder="Enter the company bio here..." v-validate required></textarea>
				<label for="bio" class="form__label">Company Bio</label>
				<div class="form__validation">{{ errors.first('company bio') }}</div>
			</div>

			<div class="form__group">
				<textarea id="context" name="context" class="form__control" v-model="formData.context"
				          placeholder="Enter the context here..." v-validate required></textarea>
				<label for="context" class="form__label">Context</label>
				<div class="form__validation">{{ errors.first('context') }}</div>
			</div>

			<div class="form__group">
				<textarea id="examples" name="buyer examples" class="form__control" v-model="formData.buyerExamples"
				          placeholder="Enter the example buyers here, use a comma after each buyer example..."
				          v-validate required></textarea>
				<label for="examples" class="form__label">Example buyers/targets</label>
				<div class="form__validation">{{ errors.first('buyer examples') }}</div>
			</div>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='"submit"'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import OpportunityFormStep from './OpportunityFormStep';
	import ValidationAlert from '../../ValidationAlert';

	export default {
		name: 'OpportunityFormStep2',
		mixins: [OpportunityFormStep],
		components: {
			ValidationAlert,
		},
		data() {
			return {
				formData: {
					companyName: null,
					location: null,
					website: null,
					description: null,
					context: null,
					buyerExamples: null,
				}
			}
		},
	}
</script>
